
export const rutas = {
    rutaRenovacionToken: 'V1/CuadernoCampo/InicioSesion/RenovarToken',
    rutaInicioSesion: 'V1/CuadernoCampo/InicioSesion',
    rutaReinicioPass: 'V1/CuadernoCampo/Usuario/ReiniciarPassword',
    rutaConfirmarReinicioPass: 'V1/CuadernoCampo/Usuario/ReiniciarPassword/Confirmar',
    rutaConfirmarUsuario: 'V1/CuadernoCampo/Usuario/ConfirmarUsuario',

    rutaRegistro: 'V1/CuadernoCampo/Registro',
    rutaExplotacion: 'V1/CuadernoCampo/Empresa',
    rutaActivarExplotacion: 'V1/CuadernoCampo/Empresa/MarcarActiva',
    rutaActividadesCubiertas: 'V1/CuadernoCampo/ActividadSobreCubierta',
    rutaAplicadores: 'V1/CuadernoCampo/Aplicadores',
    rutaAsesores: 'V1/CuadernoCampo/Asesores',
    rutaInstalacionesEdificaciones: 'V1/CuadernoCampo/InstalacionesEdificaciones',
    rutaDGCS: 'V1/CuadernoCampo/DGCS',
    rutaMaquinariasEquipos: 'V1/CuadernoCampo/MaquinariasEquipos',
    rutaTipoRegistro: 'V1/CuadernoCampo/TipoRegistro',
    rutaCultivos: 'V1/CuadernoCampo/Cultivos',

    rutaCubiertaVegetal: 'V1/CuadernoCampo/CubiertaVegetal',
    rutaCubiertaInerte: 'V1/CuadernoCampo/CubiertaInerte',
    rutaPastoreos: 'V1/CuadernoCampo/Pastoreo',
    rutaCosechas: 'V1/CuadernoCampo/Cosecha',
    rutaComercializacion: 'V1/CuadernoCampo/ComercializacionVd',
    rutaFertilizaciones: 'V1/CuadernoCampo/Fertilizaciones',
    rutaActividadesAgrarias: 'V1/CuadernoCampo/ActividadesAgrarias',
    rutaSiembraPlantacion: 'V1/CuadernoCampo/SiembraPlantacion',
    rutaAnalitica: 'V1/CuadernoCampo/Analitica',
    rutaRiegos: 'V1/CuadernoCampo/Riego',
    rutaTratamientoEdifInstalacion: 'V1/CuadernoCampo/TratamientoEdifInstalacion',
    rutaTratamientoPostCosecha: 'V1/CuadernoCampo/TratamientoPostCosecha',
    rutaTratamientoFitosanitario: 'V1/CuadernoCampo/TratamientoFitosanitario',

    rutaOperaciones: 'V1/CuadernoCampo/Operaciones/CuadernoExplotacionV2',
    rutaAuditoriaAccesos: 'V1/CuadernoCampo/Auditoria/Accesos',
    rutaAuditoriaRegistros: 'V1/CuadernoCampo/Auditoria/Registros',
    rutaSAEmpresas: 'V1/CuadernoCampo/Empresa/SuperUsuario',
    rutaSAUsuarios: 'V1/CuadernoCampo/Usuario',
    rutaVersiones: 'V1/CuadernoCampo/Version',
    rutaEnlaceComunidad: 'V1/CuadernoCampo/EnlaceComunidad',
    rutaEnlaceComunidadBase : 'V1/CuadernoCampo/EnlaceComunidad/Base',
    rutaExtensionesPermitidas: 'V1/CuadernoCampo/Documentos/Extensiones/Permitidas',
    rutaExtensionesProhibidas: 'V1/CuadernoCampo/Documentos/Extensiones/Prohibidas',
    rutaExtensionesPermitirProhibido: 'V1/CuadernoCampo/Documentos/Extensiones/PermitirProhibido',
    rutaExtensionesProhibirPermitido: 'V1/CuadernoCampo/Documentos/Extensiones/ProhibirPermitido',

    rutaGSEmpresas: 'V1/CuadernoCampo/Empresa/GestorDelSitio',

    rutaProvincias: 'V1/CuadernoCampo/Provincias',
    rutaProvinciasGetId: 'V1/CuadernoCampo/Provincias/Id',
    rutaMunicipios: 'V1/CuadernoCampo/MunicipiosIne',
    rutaComunidadesAutonomas: 'V1/CuadernoCampo/ComunidadesAutonomas',
    rutaActividadAgraria: 'V1/CuadernoCampo/ActividadAgraria',
    rutaAsociacionRazas: 'V1/CuadernoCampo/AsociacionRazas',
    rutaProductosAspafitos: 'V1/CuadernoCampo/ProductosAspafitos',
    rutaTipoCoberturasSuelosVegetal: 'V1/CuadernoCampo/TipoCoberturasSuelosVegetal/Parametrized',
    rutaTipoCoberturasSuelosInerte: 'V1/CuadernoCampo/TipoCoberturasSuelosInerte/Parametrized',
    rutaTipoMaterialFertilizante: 'V1/CuadernoCampo/MaterialFertilizante/Parametrized',
    rutaUnidadesMedida: 'V1/CuadernoCampo/UnidadesMedida/Parametrized',
    rutaTipoFertilizacion: 'V1/CuadernoCampo/TipoFertilizacion/Parametrized',
    rutaMetodoAplicacionFertilizante: 'V1/CuadernoCampo/MetodoAplicacionFertilizante/Parametrized',
    rutaBuenasPracticasFertilizantes: 'V1/CuadernoCampo/BuenasPracticasFertilizantes',
    rutaDetalleActividadAgraria: 'V1/CuadernoCampo/DetalleActividadAgraria',
    rutaFinalidadCosecha: 'V1/CuadernoCampo/FinalidadCosecha',
    rutaDestinoRestoVegetal: 'V1/CuadernoCampo/DestinoRestoVegetal',
    rutaProductos: 'V1/CuadernoCampo/Productos/Parametrized',
    rutaEficienciaTratamiento: 'V1/CuadernoCampo/EficaciaTratamiento/Parametrized',
    rutaMaterialAnalizado: 'V1/CuadernoCampo/MaterialAnalizado',
    rutaTipoAnalisis: 'V1/CuadernoCampo/TipoAnalisis',
    rutaOrigenAgua: 'V1/CuadernoCampo/OrigenAguaRiego/Parametrized',
    rutaBuenasPracticasRiego: 'V1/CuadernoCampo/BuenasPracticasRiego',
    rutaSistemaRiego: 'V1/CuadernoCampo/SistemaRiego/Parametrized',
    rutaJustificacionActuacion: 'V1/CuadernoCampo/JustificacionActuacion',
    rutaEnfermedades: 'V1/CuadernoCampo/Enfermedades',
    rutaPlagas: 'V1/CuadernoCampo/Plagas',
    rutaReguladores: 'V1/CuadernoCampo/ReguladoresCrecimientoYOtros'
}